import { ContenidosColegioEditModel, ModelValidationResult, CompromisoListItemPaginatedList, CompromisosSearch, CompromisoAceptarRequest, CompromisoAceptarResponse } from "../models/dataModels";
import { ApiFetcher } from "../utils/ApiFetcher";
import { IServiceForEdit, IServiceForIndex } from "../utils/base/BaseServices";

export class CompromisosService
    implements IServiceForIndex<CompromisosSearch, CompromisoListItemPaginatedList>, IServiceForEdit<ContenidosColegioEditModel>
{
    search(searchData: CompromisosSearch): Promise<CompromisoListItemPaginatedList> {

        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.post<CompromisosSearch, CompromisoListItemPaginatedList>("intranet/colegio/compromisos/search", searchData);
        return prom;
    }

    aceptarCompromiso(request: CompromisoAceptarRequest): Promise<CompromisoAceptarResponse> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.post<CompromisoAceptarRequest, CompromisoAceptarResponse>("intranet/colegio/compromisos/aceptar", request);
        return prom;
    }

    delete(id: number): Promise<any> {
        throw new Error("Method not implemented.");
    }

    getById(id: string | number): Promise<ContenidosColegioEditModel> {
        throw new Error("Method not implemented.");
    }
    validate(model: ContenidosColegioEditModel): Promise<ModelValidationResult> {
        var apiFetcher = new ApiFetcher();
        throw new Error("Method not implemented.");
    }

    create(model: ContenidosColegioEditModel): Promise<ContenidosColegioEditModel> {
        throw new Error("Method not implemented.");
    }

    update(id: string | number, model: ContenidosColegioEditModel): Promise<ContenidosColegioEditModel> {
        throw new Error("Method not implemented.");
    }

    exportExcel(search: CompromisosSearch): Promise<any> {
        throw new Error("Method not implemented.");
    }
}